export const getManagerSessions = state => state.sessions.manager;
export const getManagerSession = state => state.sessions.session;
export const isFetching = state => state.sessions.loading;